import { Link } from "react-router-dom";
import Me from "../../../Assets/about.jpeg";
import cook from "../../../Assets/Icons/cook.svg";
import music from "../../../Assets/Icons/music.svg";
import driving from "../../../Assets/Icons/driving.svg";
import teaTale from "../../../Assets/Icons/tea.svg";
import AdplistLogo from "../../../Assets/Icons/adplist_logo.jpeg";
import { AiOutlineLinkedin, AiOutlineInstagram } from "react-icons/ai";
import { FaGraduationCap, FaHome } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import { variants } from "../../utils/animations";
import { motion } from "framer-motion";

import "./styles.css";

const About = () => {
  return (
    <>
      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='about__container'
      >
        {/* ME */}

        <motion.div variants={variants} className='about__me'>
          <motion.div variants={variants} className='about__meText'>
            <motion.h5 variants={variants}>THAT'S ME</motion.h5>
            <motion.p variants={variants}>
              I'm Moubani Roy Choudhury, an childrens{" "}
              <Link
                style={{
                  color: "var(--primary)",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
                to='/stories'
              >
                Author
              </Link>{" "}
              and multidisciplinary{" "}
              <Link
                style={{
                  color: "var(--primary)",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
                to='/digital'
              >
                Designer
              </Link>
              .
            </motion.p>

            <motion.div
              variants={variants}
              className='about__socialIconContainer'
            >
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://www.linkedin.com/in/moubanircdesign'
                >
                  <AiOutlineLinkedin
                    style={{ fontSize: "3em", color: "var(--dark)" }}
                  />
                </a>
              </motion.div>
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://www.instagram.com/storiesbymoubani'
                >
                  <AiOutlineInstagram
                    style={{ fontSize: "3em", color: "var(--dark)" }}
                  />
                </a>
              </motion.div>
              <motion.div variants={variants} className='about__socialIcon'>
                <a
                  rel='noreferrer'
                  target='_blank'
                  href='https://adplist.org/mentors/moubani-roy-choudhury'
                  aria-label='ADPList mentor profile'
                >
                  <img
                    className='about__socialIconImage about__socialIconImage--adplist'
                    src={AdplistLogo}
                    alt='ADPList'
                  />
                </a>
              </motion.div>
            </motion.div>

            <motion.div
              variants={variants}
              className='about_horizontalLine'
            ></motion.div>
          </motion.div>

          <motion.div variants={variants} className='about__meImage'>
            <img className='about__meImage' src={Me} alt='me' />
          </motion.div>
        </motion.div>

        {/* STORY */}

        <motion.div variants={variants} className='about__data'>
          <h3>MY STORY</h3>

          <motion.p variants={variants}>
            <span style={{ color: "var(--primary)" }}>
              <FaHome style={{ fontSize: "1em", color: "var(--dark)" }} />{" "}
              Born:{" "}
            </span>
            <b>Kolkata, India</b> <br />
            <span style={{ color: "var(--primary)" }}>
              <FaGraduationCap
                style={{ fontSize: "1em", color: "var(--dark)" }}
              />{" "}
              Studied:{" "}
            </span>
            <b className='about__studied'>
              <p>St. Xavier's College, Kolkata</p>
              <p>University of the Arts London (LCC)</p>
              <p>London School of Economics & Political Science</p>
            </b>
            <span style={{ color: "var(--primary)" }}>
              <ImLocation style={{ fontSize: "1em", color: "var(--dark)" }} />{" "}
              Living:{" "}
            </span>
            <b>Milton Keynes, England</b>
            <br />
            <br />
            I grew up in a traditional Bengali home in Kolkata, the Indian city
            of art, culture, and music. I’ve always been curious about people,
            systems, and how experiences shape the way we understand the world.
            That curiosity first led me to study Sociology at St. Xavier’s
            College, Kolkata, where I became interested in human behaviour and
            social systems. Alongside this, I developed a growing interest in
            visual communication and design.
            <br />
            <br />
            My professional journey began in 2015 as a research intern at Child
            Rights and You (CRY), where I created posters and videos and quickly
            became the informal “design person” on the team. I then moved into
            an unexpected role at a tea auction house, where I worked across tea
            tasting, recruitment, and marketing, and progressed into a
            managerial position. This experience taught me how to work across
            disciplines, manage complexity, and adapt quickly across very
            different types of work. What consistently drew me in was making
            information clearer and more intuitive organising complexity, using
            structure and visual thinking, and finding ways to improve how
            things are understood. This led me to formally learn design tools
            and eventually launch my own design brand, Mbony India, in 2017. The
            response to my work confirmed what I already felt strongly: I wanted
            to build a career in design.
            <br />
            <br />
            I transitioned into the design field full time, starting as an art
            director before moving into UI design, and eventually specialising
            in UX design where design, technology, and business intersect with a
            deep understanding of human behaviour. I later completed a Master’s
            in User Experience Design at the University of the Arts London and
            deepened my research practice at the London School of Economics and
            Political Science.
            <br />
            <br />
            Today, I work as a UX Designer in the public sector, focusing on
            accessibility and inclusive design for complex systems. I have also
            worked across early-stage startups and established organisations,
            delivering end-to-end UX projects across public and private sector
            contexts.
            <br />
            <br />
            Alongside my design career, I am a children’s author. Moving across
            continents and building a multicultural family made me realise the
            absence of children’s stories that reflected multilingual, blended,
            and diverse identities like ours. That gap led me to writing
            bilingual children’s books that centre cultural diversity,
            representation, and belonging. For me, writing is not separate from
            my lived experience, it is a way of creating visibility where it is
            often missing. I aim to create stories that act as both windows and
            mirrors for children, helping them see both themselves and others
            more clearly.
          </motion.p>
        </motion.div>

        {/* VALUES */}

        <motion.div variants={variants} className='about__data'>
          <h3>VALUES</h3>

          <motion.p variants={variants}>
            Across both UX design and writing, I am driven by the same core
            intention: to understand human experience and create work that is
            more accessible, inclusive, and reflective of the diversity of the
            world we live in. Outside of work, I mentor emerging designers
            through ADPList and continue to explore creative expression through
            writing, design, and everyday life.
            <br />
            <br />
            When I’m not working, I can be found teaching and learning yoga,
            talking to my plants, experimenting with new recipes, doodling away
            in my journal or teaching my dog (or son) a new trick!
          </motion.p>
        </motion.div>

        {/* LANG */}

        <motion.div variants={variants} className='about__lang'>
          <h3>LANGUAGES I READ & WRITE</h3>

          <motion.p variants={variants}>
            English (UK and US) | Bengali (Native) | Hindi (Proficient)
          </motion.p>
        </motion.div>

        <motion.div
          variants={variants}
          className='about_horizontalLine'
        ></motion.div>

        {/* FUN FACTS */}

        <motion.div variants={variants} className='about__funFact'>
          <h3>FUN FACTS</h3>

          <motion.div variants={variants}>
            <FunFact
              icon={teaTale}
              title='Tea tales'
              description="I'm a certified tea taster with 3.5years of industry experience"
            />
            <FunFact
              icon={cook}
              title='Spice of life'
              description="I'm a food connoisseur and someday wish to have my own restaurant."
            />
            <FunFact
              icon={driving}
              title='Go slow!'
              description='I was called Lady-Schumacher for my driving'
            />
            <FunFact
              icon={music}
              title='Sound of music'
              description="I grew up in a musical family and that's the way to my heart."
            />
          </motion.div>
        </motion.div>
      </motion.div>
    </>
  );
};

export default About;

const FunFact = ({ icon, title, description }) => {
  return (
    <motion.div
      initial='hidden'
      whileInView='visible'
      variants={variants}
      className='funFact__container'
    >
      <motion.div variants={variants} className='funFact__icon'>
        <img src={icon} alt='' />
      </motion.div>

      <motion.div variants={variants} className='funFact__title'>
        <motion.p>{title}</motion.p>
      </motion.div>

      <motion.div variants={variants} className='funFact__description'>
        <motion.p>{description}</motion.p>
      </motion.div>
    </motion.div>
  );
};
